import React from 'react';
import { FormattedMessage } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { Sidebar } from '@futrli/ui-components';
import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { DuplicateDashboardContainer } from './containers/duplicate-dashboard-container';
import { DuplicateDashboardContextProvider } from './context/duplicate-dashboard-context';

interface DuplicateDashboardSidebarProps {
  dashboardId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const DuplicateDashboardSidebar = ({ dashboardId, isOpen, onClose }: DuplicateDashboardSidebarProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (!dashboardId) {
    return null;
  }

  return (
    <Sidebar
      header={
        <>
          <Typography variant="h2" fontWeight="700">
            <FormattedMessage id="predict.dashboards.duplicate" defaultMessage="Duplicate dashboard" />
          </Typography>
        </>
      }
      onCancel={onClose}
      open={isOpen}
    >
      <DuplicateDashboardContextProvider key={resetKey} dashboardId={dashboardId}>
        <DuplicateDashboardContainer onClose={onClose} />
      </DuplicateDashboardContextProvider>
    </Sidebar>
  );
};
